/** 服务项目管理API */
import type { Api } from '@/typings/api';
import { download, post, upload } from '../../request';
const prefix = '/store/serviceItem';
/**
 * 分页查询服务项目管理
 *
 * @param params 查询参数
 */
export const findPage: Api.CommonMethods.FindPage<Api.Store.ServiceItem> = params => {
  return post(`${prefix}/findPage`, params);
};
/**
 * 查询服务项目管理列表
 *
 * @param params 查询参数
 */
export const findAll: Api.CommonMethods.FindAll<Api.Store.ServiceItem> = params => {
  return post(`${prefix}/findAll`, params);
};
/**
 * 查询单个服务项目管理
 *
 * @param id 服务项目管理ID
 * @param column 查询字段
 */
export const findOne: Api.CommonMethods.FindOne<Api.Store.ServiceItem> = (id: string, column?: string[]) => {
  return post(`${prefix}/findOne`, { id, column });
};
/**
 * 保存服务项目管理
 *
 * @param params 服务项目管理信息
 */
export const doSave: Api.CommonMethods.Save = params => {
  return post(`${prefix}/save`, params);
};
/**
 * 更新服务项目管理信息
 *
 * @param params 服务项目管理信息
 */
export const doUpdate: Api.CommonMethods.Update = params => {
  return post(`${prefix}/update`, params);
};
/**
 * 删除服务项目管理
 *
 * @param id 服务项目管理ID
 */
export const doDelete: Api.CommonMethods.Delete = id => {
  return post(`${prefix}/delete?id=${id}`);
};
/**
 * 批量删除服务项目管理
 *
 * @param ids 服务项目管理ID数组
 */
export const doBatchDelete: Api.CommonMethods.BatchDelete = ids => {
  return post(`${prefix}/deleteList`, { ids });
};

/**
 * 导出
 *
 * @param params
 * @returns
 */
export const doExport = (params: Api.Common.CommonSearchParams) => {
  return download(`${prefix}/export`, params);
};

/**
 * 导入
 *
 * @param file 文件
 * @param params
 * @returns
 */
export const doImport = (file: File, params: Api.Common.ImportParams = { isCustom: true }) => {
  return upload(`${prefix}/import`, file, params);
};

export default {
  findPage,
  findOne,
  doSave,
  doUpdate,
  doDelete,
  doBatchDelete
};
